import createLucideIcon from '../createLucideIcon';

const ChevronsLeft = createLucideIcon('ChevronsLeftIcon', [
  ['polyline', { points: '11 17 6 12 11 7', key: '1ueymj' }],
  ['polyline', { points: '18 17 13 12 18 7', key: '18fy0m' }],
]);

export default ChevronsLeft;
